import { useLocation, useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./timetable.css";

export default function TimetableEditor() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const school = JSON.parse(localStorage.getItem("schoolAdmin"))?.school;

  // ✅ WEEKLY DATA
  const class_id = state?.class_id;
  const section_id = state?.section_id;
  const day = state?.day;

  // 🔒 HARD BLOCK
  if (!class_id || !section_id || !day) {
    return (
      <div className="tt-page">
        <h2 className="tt-title">Weekly Timetable</h2>
        <p style={{ color: "red" }}>
          Please select Class, Section and Day first.
        </p>
        <button
          className="tt-btn"
          onClick={() => navigate("/school-admin/timetable")}
        >
          Go to Timetable Dashboard
        </button>
      </div>
    );
  }

  // ✅ CREATE WEEKLY DAY
  const createDay = async (session) => {
    try {
      const res = await API.post(
        "/school-admin/weekly-timetable/day/create/",
        {
          class_id,
          section_id,
          day,
          session,
        },
        { headers: { "X-SCHOOL-ID": school.id } }
      );

      navigate("/school-admin/timetable/view", {
        state: {
          day_id: res.data.day_id,
          class_id,
          section_id,
          day,
          session,
        },
      });
    } catch (err) {
      alert("Failed to create weekly timetable session");
    }
  };

  return (
    <div className="tt-page">
      <h2 className="tt-title">
        Weekly Timetable – {day.toUpperCase()}
      </h2>

      <div className="tt-session-box">
        <button
          className="tt-btn morning"
          onClick={() => createDay("morning")}
        >
          🌅 Morning Session
        </button>

        <button
          className="tt-btn evening"
          onClick={() => createDay("evening")}
        >
          🌙 Evening Session
        </button>
      </div>
    </div>
  );
}